export * from '@primeuix/themes/lara/rating';
export { default } from '@primeuix/themes/lara/rating';
